import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY

export const getHistoricData = (setHistoricoData, userId) => {
    api.get(`${urlApi}/humanGrowth/getHumanGrowth?userId=${userId.ID}`).then((res) => {
        setHistoricoData(res.data);
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const individualOperatorAnalysis = (setHistoricoData, userId) => {
    api.get(`${urlApi}/humanGrowth/individualOperatorAnalysis?userId=${userId.ID}`).then((res) => {
        setHistoricoData(res.data);
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getGeneralData = (setGeneralData) => {
    api.get(`${urlApi}/humanGrowth/getDataGeneral`).then((res) => {
        setGeneralData(res.data);
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getOperatorMotivationTrend = (setGeneralData) => {
    api.get(`${urlApi}/humanGrowth/getOperatorMotivationTrend`).then((res) => {
        setGeneralData(res.data);
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getColaboradorData = (setColaboradorData) => {
    api.get(`${urlApi}/humanGrowth/getColaboradorData`).then((res) => {
        setColaboradorData(res.data);
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getMoodByOperator = (setColaboradorData) => {
    api.get(`${urlApi}/humanGrowth/getMoodByOperator`).then((res) => {
        setColaboradorData(res.data);
    })
        .catch((error) => {
            console.log("error", error);
        })
}

export const getDepartamentoData = (departamentoData, userId) => {
    api.get(`${urlApi}/humanGrowth/getDepartamentoData`).then((res) => {
        departamentoData(res.data);
    })
        .catch((error) => {
            console.log("error", error);
        })
}
